export interface VerificationDto {
  challenge: VerificationChallengeDto | null;
  finished: VerificationFinishedDto | null;
}

export interface VerificationChallengeDto {
  verificationId: string;
  difficulty: number;
  tasks: VerificationChallengeTaskDto[];
}

export interface VerificationChallengeTaskDto {
  number: number;
  input: string;
}

export interface VerificationFinishedDto {
  verificationToken: string;
  expiresInMs: number;
}
